import { useMutation } from "react-query";
import { saveMatchType } from "components/duplicate-staging/lib/productData";

export const useSaveMatchType = () => {
    return useMutation(({ taskContextKey, matchType, matchesTaskContextKey }) => saveMatchType(taskContextKey, matchType, matchesTaskContextKey));
};
